import { useState } from "react";
import { useParams } from "react-router-dom";
import { getStoredAccountType } from "../auth";
import { AdmissionsPage } from "./AdmissionsPage";
import { AdmissionDetailPage } from "./AdmissionDetailPage";
import { EnterpriseAdmissionsPage } from "./EnterpriseAdmissionsPage";
import { HospitalAdmissionsPage } from "./HospitalAdmissionsPage";

export function AdmissionsPageRouter() {
  const [accountType] = useState(() => getStoredAccountType());
  const { id } = useParams();
  const admissionId = id ? Number.parseInt(id, 10) : NaN;

  if (!Number.isNaN(admissionId) && admissionId > 0) {
    if (accountType === "hospital") {
      return <AdmissionDetailPage admissionId={admissionId} scope="hospital" />;
    }
    if (accountType === "enterprise") {
      return <AdmissionDetailPage admissionId={admissionId} scope="company" />;
    }
    if (accountType === "auditor") {
      return <AdmissionDetailPage admissionId={admissionId} scope="auditor" />;
    }
    if (accountType === "admin") {
      return <AdmissionDetailPage admissionId={admissionId} scope="admin" />;
    }
  }

  if (accountType === "enterprise") {
    return <EnterpriseAdmissionsPage />;
  }

  if (accountType === "hospital") {
    return <HospitalAdmissionsPage />;
  }

  return <AdmissionsPage />;
}
